<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header bg-dark text-white">
                Quiz Setup
            </div>
            <div class="card-body">
                <form #form="ngForm" (submit)='submitForm(form)' method="post" class="form-api">
                    <div class="form-group">
                        <label for="trivia_amount">Number of Questions:</label>
                        <select name="trivia_amount" required class="form-control"
                            aria-describedby="triviaAmountHelpBlock" [(ngModel)]="model.triviaAmount" #triviaAmount="ngModel" 
                            [class.is-valid]="triviaAmount.touched && triviaAmount.valid && !triviaAmount.errors" 
                            [class.is-invalid]="triviaAmount.touched && triviaAmount.invalid && triviaAmount.errors"
                            (change)="updatePlayTime($event.target.value);completeStep($event.target.name)">
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="40">40</option>
                            <option value="50">50</option>
                        </select>
                        <small id="triviaAmountHelpBlock" class="form-text text-muted">
                            Play time: {{playTime}} minutes
                        </small>
                    </div>

                    <div class="form-group">
                        <label for="trivia_category">Select Category: </label>
                        <select name="trivia_category" required class="form-control" [(ngModel)]="model.triviaCategory" #triviaCategory="ngModel" 
                        [class.is-valid]="triviaCategory.touched && triviaCategory.valid" [class.is-invalid]="triviaCategory.touched && triviaCategory.invalid"
                            (change)="completeStep($event.target.name)">
                            <option value="any">Any Category</option>
                            <option value="9">General Knowledge</option>
                            <option value="10">Entertainment: Books</option>
                            <option value="11">Entertainment: Film</option>
                            <option value="12">Entertainment: Music</option>
                            <option value="13">Entertainment: Musicals &amp; Theatres</option>
                            <option value="14">Entertainment: Television</option>
                            <option value="15">Entertainment: Video Games</option>
                            <option value="16">Entertainment: Board Games</option>
                            <option value="17">Science &amp; Nature</option>
                            <option value="18">Science: Computers</option>
                            <option value="19">Science: Mathematics</option>
                            <option value="20">Mythology</option>
                            <option value="21">Sports</option>
                            <option value="22">Geography</option>
                            <option value="23">History</option>
                            <option value="24">Politics</option>
                            <option value="25">Art</option>
                            <option value="26">Celebrities</option>
                            <option value="27">Animals</option>
                            <option value="28">Vehicles</option>
                            <option value="29">Entertainment: Comics</option>
                            <option value="30">Science: Gadgets</option>
                            <option value="31">Entertainment: Japanese Anime &amp; Manga</option>
                            <option value="32">Entertainment: Cartoon &amp; Animations</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label for="trivia_difficulty">Select Difficulty: </label>
                        <select name="trivia_difficulty" required class="form-control" #triviaDifficulty="ngModel" 
                        [class.is-valid]="triviaDifficulty.touched && triviaDifficulty.valid" [class.is-invalid]="triviaDifficulty.touched && triviaDifficulty.invalid"
                            [(ngModel)]="model.triviaDifficulty" (change)="completeStep($event.target.name)">
                            <option value="any">Any Difficulty</option>
                            <option value="easy">Easy</option>
                            <option value="medium">Medium</option>
                            <option value="hard">Hard</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label for="trivia_type">Select Type: </label>
                        <select name="trivia_type" required class="form-control" [(ngModel)]="model.triviaType" #triviaType="ngModel" 
                        [class.is-valid]="triviaType.touched && triviaType.valid" [class.is-invalid]="triviaType.touched && triviaType.invalid"
                            (change)="completeStep($event.target.name)">&gt;
                            <option value="any">Any Type</option>
                            <option value="multiple">Multiple Choice</option>
                            <option value="boolean">True / False</option>
                        </select>
                    </div>

                    <button class="btn btn-primary btn-block" id="btnSubmit" disabled="disabled" [disabled]="form.invalid" type="submit">Start
                        Quiz</button>
                </form>
            </div>
        </div>
    </div>
</div>